import FAQExpandableRow from '@/components/FAQExpandableRow';
import PageLayout from '@/components/PageLayout';
import Footer from '@/components/PageLayout/Footer';
import { NavBarLightTheme } from '@/components/PageLayout/PageNavBar';
import TwelveColGrid from '@/components/TwelveColGrid';
import { Faq } from '@/lib/interfaces';
import { faqs } from '@/utils/faqs';

export default function FAQPage() {
  return (
    <PageLayout>
      <NavBarLightTheme />
      <TwelveColGrid my="mt-1.6 mb-4.8 lgt:mb-28 lgt:mt-8.0">
        <div className="col-span-12 relative bg-artcollection bg-cover lgt:bg-center h-49.6 lgt:h-56.0 p-2.4 lgt:py-3.2">
          <h5 className="mb-1.6 text-center lgt:text-left copy-xl">
            HAVE A QUESTION?
          </h5>
          <p className="text-center text-body lgt:text-left lgt:max-w-2xl">
            Take a look at some frequently asked questions, or feel free to send
            us an email and we will get back to you.
          </p>
        </div>
      </TwelveColGrid>
      <TwelveColGrid my="mb-48">
        <div className="col-span-12">
          {faqs.map((v: Faq) => (
            <FAQExpandableRow
              key={v.question}
              question={v.question}
              answer={v.answer}
            />
          ))}
          <div className="h-1 -mt-1 border border-white"></div>
        </div>
      </TwelveColGrid>
      <Footer />
    </PageLayout>
  );
}
